module.exports = __webpack_public_path__ + "static/img/2.186363f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 1